var ɵ0 = function (moment) {
    return function (input) {
        return moment(input).format("MMM DD, YYYY hh:mm A");
    };
};
var filter = ['moment', ɵ0];
export var FourDotFiveTimeStampFormatFilter = {
    name: 'fourdotfiveTimeStampFormat',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-time-stamp-format.filter.js.map